<template>
    <div class="past-addresses">
        <div v-if="pastAddresses" class="main">
            <div class="map-wrapper">
                <div :id="mapID" class="map" />
            </div>


            <div class="bottom">
                <!-- <div v-if="showList"> -->
                <div class="addresses is-pointer">
                    <!-- <p class="label" @click="toggleList">Select to zoom in -->
                    <span class="button is-small is-rounded is-pulled-right" @click="toggleList">
                        <i v-if="showList" class="fa fa-chevron-down" />
                        <i v-else class="fa fa-chevron-up" />
                    </span>
                    <p class="buttons" style="margin-bottom: 6px">
                        <span class="button is-small is-rounded" :class="{ 'is-dark': dropoffDrawn }"
                            @click="drawDropoffPoints">Dropoff Points</span>
                        <span class="button is-small is-rounded" :class="{ 'is-dark': alightedDrawn }"
                            @click="drawAlightedPoints">Alighted Points</span>
                        <span class="button is-small is-rounded" @click="zoomToUser">You</span>
                    </p>
                    <div v-if="showList">
                        <div v-for="a in pastAddresses" :key="a.created_at" class="is-flex" @click="selectDelivery(a)">
                            <p class="time-ago">{{ timeAgo(a.created_at) }}</p>
                            <p class="name no-scrollbar">{{ a.dropoff_name }} - {{ a.dropoff_notes }}</p>
                            <p class="diff-meters monospace">
                                {{ a.diff_meters > 999 ? 999 : a.diff_meters }}m
                            </p>
                        </div>
                    </div>
                </div>
                <div class="bottom-bar is-flex">
                    <p class="is-pointer" style="flex-shrink: 1" @click="goBack">
                        <i class="fa fa-chevron-left" />
                        {{ $t("back") }}
                    </p>
                    <p style="flex: 1; text-align:right" @click="toggleList">
                        {{ pastAddresses.length }}<span v-if="pastAddresses.length > 9">+</span> Past Deliveries
                    </p>
                </div>
            </div>

            <div class="top-bar">
                <div class="is-flex">
                    <p style="flex-shrink:1">Past Addresses</p>
                    <p style="flex: 1; text-align: right">
                        <span v-if="ongoingDeliveries.length" class="has-text-danger">
                            {{ ongoingDeliveries.length }} Ongoing</span>
                        <span v-else>No Ongoing Deliveries</span>
                    </p>
                </div>
                <div v-if="selectedDelivery" class="selected-delivery">
                    <p class="time-ago monospace has-text-grey">
                        {{ timeAgo(selectedDelivery.created_at) }} - {{ $h.shortDate(selectedDelivery.created_at) }}
                    </p>
                    <p class="name no-scrollbar">{{ selectedDelivery.dropoff_name || '[Pin Location]' }} - {{
                        selectedDelivery.dropoff_notes }}
                    </p>
                    <p class="diff-meters">
                        Diff: {{ selectedDelivery.diff_meters }}m

                    </p>
                    <p style="margin-top:5px">
                        <span class="button is-small is-info" style='padding:4px' @click="copyAlightedCoords">
                            Alighted Coords&nbsp;&nbsp;<b>{{ alightedCoordsString }}</b>
                        </span>
                        <span class="is-pulled-right button is-small is-rounded" @click="selectedDelivery = null">
                            <i class="fa fa-chevron-up" />
                        </span>
                    </p>
                </div>
            </div>
        </div>
        <div v-else class="loading" @click="goHome">
            Loading Past Addresses...
        </div>

    </div>
</template>

<script>
import L from "leaflet";
import "leaflet.locatecontrol";
import "leaflet.awesome-markers";

const CachedTileLayer =
    require("@yaga/leaflet-cached-tile-layer").CachedTileLayer;

export default {
    name: "PastAddresses",
    props: {
        id: String,
    },
    data() {
        return {
            mapID: "past-addresses-map",
            map: null,
            warning: null,
            straightLine: null,
            layer: null, // main layer
            dropoffLayer: null,
            alightedLayer: null,
            selectedLayer: null,
            pastAddresses: null,
            padding: { padding: [50, 50] },
            selectedDelivery: null,
            showList: true,
            dropoffDrawn: false,
            alightedDrawn: false,
            userMarker: null,
        };
    },
    computed: {
        initCoords() {
            if (!this.pastAddresses || !this.pastAddresses.length)
                return { lat: 0, lng: 0 }
            var a = this.pastAddresses[0]
            return { lat: a.dropoff_lat, lng: a.dropoff_lon }
        },
        ongoingDeliveries() {
            if (!this.pastAddresses) return [];
            return this.pastAddresses.filter(a => a.state !== 'alighted');
        },
        alightedCoordsString() {
            if (!this.selectedDelivery || !this.selectedDelivery.alighted_lat) return 'None Yet'
            return `${this.selectedDelivery.alighted_lat}, ${this.selectedDelivery.alighted_lon}`
        }
    },
    mounted() {
        this.getPastAddresses();
    },
    methods: {
        getPastAddresses() {
            this.$store
                .dispatch("getPastAddresses", this.id)
                .then((res) => {
                    this.pastAddresses = res.data;
                    this.$nextTick(() => this.initMap());
                })
                .catch((err) => this.apiError(err));
        },
        copyAlightedCoords() {
            this.infoToast("Copied coords")
            this.$copyText(this.alightedCoordsString, "top")
        },
        selectDelivery(a) {
            this.selectedDelivery = a
            this.drawSelected();
            this.toggleList();
        },
        toggleList() {
            this.showList = !this.showList;
        },
        goBack() {
            this.pastAddresses = null;
            this.$router.go(-1); // go back
        },
        initMap() {
            var tilesURL = this.$t("geo.map-tiles"); // language specific maps

            this.map = L.map(this.mapID, { attributionControl: false });
            this.map.setView(this.initCoords, 17);
            L.tileLayer(tilesURL, {
                tileSize: 512,
                zoomOffset: -1,
                // minZoom: 12,
                maxZoom: 19,
            }).addTo(this.map);

            new CachedTileLayer(tilesURL, {
                tileSize: 512,
                zoomOffset: -1,
                minZoom: 2,
                maxZoom: 19,
                // useCache: false,
                // cacheMaxAge: 1000 * 60 * 60 * 24 * 30, // 30 days
                crossOrigin: true,
                maxAge: 1000 * 60 * 60 * 24 * 30, // optional, default is 7 days
            }).addTo(this.map);

            this.map.zoomControl.remove();

            this.layer = L.featureGroup().addTo(this.map);
            this.dropoffLayer = L.featureGroup().addTo(this.map);
            this.alightedLayer = L.featureGroup().addTo(this.map);
            this.selectedLayer = L.featureGroup().addTo(this.map);

            this.drawUser();

            // var group = new L.featureGroup([pickupMarker, dropoffMarker]);
            // var padding = { padding: [50, 50] };
            // this.map.fitBounds(group.getBounds(), padding);

            // // add popups
            // var opts = { closeButton: false, autoPan: true };
            // var pStr = this.$t("driver.pickup");
            // var dStr = this.$t("driver.dropoff");
            // var pickupName = this.pickup.name || this.$t("ride.pin-location");
            // var dropoffName = this.dropoff.name || this.$t("ride.pin-location");
            // pickupMarker.bindPopup(`<i>${pStr}</i><br>${pickupName}`, opts);
            // dropoffMarker.bindPopup(`<i>${dStr}</i><br>${dropoffName}`, opts);
            // setTimeout(() => pickupMarker.openPopup(), 1000);
            // setTimeout(() => dropoffMarker.openPopup(), 3000);
        },
        drawUser() {
            var coords = this.$store.getters.getUserLatLon;
            var icon = L.divIcon({
                html: `<div class="blue-dot pulse"></div>`,
                popupAnchor: [7, -6],
                className: "none",
            });
            this.userMarker = L.marker(coords, { icon: icon });
            this.userMarker.addTo(this.layer);
            var popupOpts = { closeButton: false, autoPan: true };
            this.userMarker.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
        },
        zoomToUser() {
            this.map.setView(this.userMarker.getLatLng(), 16); // 15 = old town size
            this.showList = false;
        },
        drawPastAddresses() {
            this.pastAddresses.forEach((a) => {
                this.drawPastAddress(a)
            })
            this.zoomOut();
            console.log("pastAddresses", this.pastAddresses);
        },
        drawDropoffPoints() {
            if (this.dropoffDrawn) {
                this.dropoffLayer.clearLayers();
                this.dropoffDrawn = false;
                return
            }
            this.dropoffDrawn = true;
            this.pastAddresses.forEach((a) => {
                var addressMarker = L.circleMarker(this.addressCoords(a), {
                    radius: 5,
                    color: "green"
                });
                addressMarker.addTo(this.dropoffLayer);
            })
            this.zoomTo(this.dropoffLayer);
            this.showList = false;
        },
        drawAlightedPoints() {
            if (this.alightedDrawn) {
                this.alightedLayer.clearLayers();
                this.alightedDrawn = false;
                return
            }
            this.alightedDrawn = true;
            this.pastAddresses.forEach((a) => {
                var alightedMarker = L.circleMarker(this.alightedCoords(a), {
                    radius: 3,
                    color: "black"
                });
                alightedMarker.addTo(this.alightedLayer);
            })
            this.zoomTo(this.alightedLayer);
            this.showList = false;
        },
        drawSelected() {
            var a = this.selectedDelivery;
            var addressMarker = L.circleMarker(this.addressCoords(a), {
                radius: 6,
                color: "green"
            });
            addressMarker.addTo(this.layer);
            var alightedMarker = L.circleMarker(this.alightedCoords(a), {
                radius: 10,
                color: "black"
            });
            alightedMarker.addTo(this.layer);
            var latlngs = Array();
            latlngs.push(addressMarker.getLatLng());
            latlngs.push(alightedMarker.getLatLng());
            this.driverLine = L.polyline(latlngs, {
                color: "orange",
                opacity: 0.8,
                weight: "2",
                dashArray: "5, 6",
            }).addTo(this.layer);
            //     this.redrawLineOnZoom(this.driverLine);
        },
        zoomTo(layer) {
            this.map.fitBounds(layer.getBounds(), this.padding);
        },
        // zooms in to a single delivery
        zoomIn(a) {
            this.map.fitBounds(a.layer.getBounds(), this.padding);
        },
        // zooms out to all deliveries
        zoomOut() {
            this.map.fitBounds(this.layer.getBounds(), this.padding);
        },
        addressCoords(a) {
            return { lat: a.dropoff_lat, lng: a.dropoff_lon };
        },
        alightedCoords(a) {
            return { lat: a.alighted_lat, lng: a.alighted_lon };
        },
        drawPastAddress(a) {
            // var pickupIcon = L.AwesomeMarkers.icon({
            //     icon: "store-alt", //"street-view",
            //     markerColor: "blue",
            // });

            // var dropoffIcon = L.AwesomeMarkers.icon({
            //     icon: "flag-checkered",
            //     markerColor: "lightgreen",
            //     iconColor: "blue",
            //     extraClasses: "fa-lg",
            // });

            // // L.circle is in meters
            // var addressMarker = L.circle(this.addressCoords(a), {
            //     color: 'red',
            //     fillColor: '#f03',
            //     fillOpacity: 0.5,
            //     radius: 500
            // });

            // L.circleMarker is in pixels
            var addressMarker = L.circleMarker(this.addressCoords(a), {
                radius: 6,
                color: "green"
            });
            addressMarker.addTo(this.layer);
            var alightedMarker = L.circleMarker(this.alightedCoords(a), {
                radius: 10,
                color: "blue"
            });
            alightedMarker.addTo(this.layer);

            a.layer = L.featureGroup();
            // addressMarker.addTo(a.layer);
            // alightedMarker.addTo(a.layer);
            a.layer.addLayer(addressMarker);
            a.layer.addLayer(alightedMarker);
            addressMarker.on("click", (a) => this.zoomIn(a));
            alightedMarker.on("click", (a) => this.zoomIn(a));
            console.log("a", a);
        }
    },
};
</script>

<style scoped>
.past-addresses {
    background-color: #333;
    height: 100vh;
    width: 100vw;
}

.addresses {
    text-align: left;
    /* margin-bottom: 8px; */
}

.addresses .is-flex {
    background-color: #eee;
    margin-bottom: 10px;
    /* padding: 0 2px; */
    border-radius: 2px;
}

.addresses .diff-meters {
    width: 50px;
    background-color: #333;
    color: white;
    text-align: right;
}

.addresses .time-ago {
    width: 80px;
    background-color: white;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.addresses .name {
    flex-grow: 1;
    white-space: nowrap;
    overflow: scroll;
    width: 50px;
}

.addresses p {
    padding: 0 2px;
}

.map-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 1;
}

.map {
    position: relative;
    height: 100%;
    width: 100%;
}

.bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    background-color: #ddd;
    padding: 12px 16px;
    /* z-index: 1101; */
    z-index: 2;
    box-shadow: 0 0 3px black;
}

.warning.tag {
    border-radius: 0;
}

.selected-delivery {
    margin-top: 5px;
    padding-top: 5px;
    border-top: 1px solid #555;
}

.top-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    background-color: #333;
    padding: 12px;
    z-index: 2;
    box-shadow: 0 0 3px black;
    text-align: left;
    color: white;
}

.is-flex .button {
    flex: 1;
}

.distance {
    /* background-color: #777; */
    background-color: #ddd;
    color: #333;
    border-radius: 3px;
    padding: 0 4px;
    display: inline-block;
    border: 1px solid white;
    font-weight: 500;
}

.distance.dark {
    background-color: #333;
    color: white;
}

.fare-info {
    margin: 12px 0;
    background-color: #666;
    border-radius: 3px;
    padding: 0 4px;
}

.fare {
    display: inline-block;
    background-color: #444;
    border-radius: 3px;
    padding: 0 3px;
    margin: 4px;
}

.source {
    position: absolute;
    bottom: 60px;
    right: 10px;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    border-radius: 3px;
    padding: 0 3px;
}

.loading {
    padding: 30px;
    color: white;
}
</style>

<style lang="scss">
#past-addresses-map {
    .leaflet-control-locate {
        border-radius: 50%;
    }

    .leaflet-control-locate a {
        border-radius: 50%;
    }

    .leaflet-popup-content {
        padding: 5px 5px;
        margin: 1px 0;
        // color: rgb(23, 23, 193);
        color: rgb(23, 102, 193);
        font-size: 1.2em;
        max-width: 130px;
    }

    .leaflet-popup-content i {
        font-weight: 500;
        opacity: 0.8;
        color: grey;
    }

    .blue-dot {
        margin-left: 6px;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        background-color: #2693da;
        opacity: 0.9;
        border: 1px solid #feeaa4b5;
    }

    .pulse {
        animation: pulsate-1 3s ease-out infinite;
    }

    @keyframes pulsate-1 {
        0% {
            box-shadow: 0 0 0 1px cyan;
        }

        50% {
            box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
        }

        100% {
            box-shadow: 0 0 0 1px lightskyblue;
        }
    }
}
</style>